const getFollowersStats = (socialMediaStats) => {
  let instagramFollowers;
  let facebookFollowers;
  let totalFollowers = 0;

  socialMediaStats.forEach((sm) => {
    if (sm.type === 'facebook') {
      facebookFollowers = sm.data.followers;
      if (facebookFollowers) totalFollowers += parseInt(facebookFollowers);
    } else if (sm.type === 'instagram') {
      instagramFollowers = sm.data.followers.count;
      if (instagramFollowers) totalFollowers += parseInt(instagramFollowers);
    }
  });

  return { instagramFollowers, facebookFollowers, totalFollowers };
};

export const formatNumber = (val) =>
  typeof val === 'number' ? new Intl.NumberFormat('en-US').format(val) : val;

export const formatSocialMediaData = (data) =>
  data.map((item) => {
    const learnerData = item?.learnerData;

    const mostRecent = item.dailyLogs.length - 1;
    const socialMediaStats = item.dailyLogs
      ? item.dailyLogs[mostRecent].socialMedia
      : [];

    const {
      facebookFollowers,
      instagramFollowers,
      totalFollowers,
    } = getFollowersStats(socialMediaStats);

    const formatted = {
      ...learnerData,
      facebookFollowers,
      instagramFollowers,
      totalFollowers,
    };

    return formatted;
  });

const getChartItemData = (currentLog) => {
  let {
    instagramFollowers,
    facebookFollowers,
    totalFollowers,
  } = getFollowersStats(currentLog.socialMedia);

  return {
    facebook: facebookFollowers,
    instagram: instagramFollowers,
    total: totalFollowers,
    date: currentLog.createdAt,
  };
};

const sortByDate = (a, b) => {
  const dateA = new Date(a.date);
  const dateB = new Date(b.date);

  return dateA - dateB;
};

export const getChartDataFormat = (timelineData) => {
  const logData = [];

  if (!timelineData) return;

  timelineData.forEach((currentLog) => {
    logData.push(getChartItemData(currentLog));
  });

  return logData.sort(sortByDate);
};
